import { Pipe, PipeTransform } from '@angular/core';
import { stringifyAddress } from '@k2/common/addresses/utils';
import { Address, toAddress } from '@k2/common/entities-state/types';
import { HhgAddress, HhgDestinationAddress, HhgOriginAddress, HhgOriginStorageAddress } from '@k2/staff/content/clients/client/assignment/hhg/overview/addresses/list/addresses-list.component';
import * as _ from 'lodash';

/**
 * Transforms location object into Google Maps link.
 */
@Pipe({
  name: 'gMapLink',
  standalone: false
})
export class GMapLinkPipe implements PipeTransform {
  transform(address: Address | HhgAddress | HhgOriginAddress | HhgOriginStorageAddress | HhgDestinationAddress): string {
    if (_.isEmpty(address)) return;
    if (!('address1' in address)) {
      address = toAddress(address);
    }
    return toGMapUrl('https://maps.google.com/?q=', address);
  }
}

/**
 * Transforms location object into Google Maps link,
 * which can be used to embed a map into the website.
 */
@Pipe({
  name: 'embedGMapLink',
  standalone: false
})
export class EmbedGMapLinkPipe implements PipeTransform {
  transform(address: Address): string {
    if (address == null) return;
    return toGMapUrl('https://www.google.com/maps/embed/v1/place?q=', address);
  }
}

function toGMapUrl(prefix: string, address: Address) {
  return encodeURI(prefix + stringifyAddress(address));
}
